import { render, staticRenderFns } from "./JobCategoryDetailPage.vue?vue&type=template&id=54b56f3b&scoped=true"
import script from "./JobCategoryDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JobCategoryDetailPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobCategoryDetailPage.vue?vue&type=style&index=0&id=54b56f3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b56f3b",
  null
  
)

export default component.exports